<template>
  <div :class="[size === 'small' ? 'chi-photo-xs' : 'chi-photo']">
    <img
      class="rounded-full"
      :src="profilePhoto"
      :alt="alt"
      :title="alt"
      @error="imgPlaceholder"
    />
  </div>
</template>

<script>
export default {
  name: "Photo",
  props: ["src", "alt", "size"],
  computed: {
    profilePhoto() {
      return `https://ap2.chinet.org/api/v1.0${this.src}/sm`;
    },
  },
  methods: {
    imgPlaceholder(e) {
      e.target.src =
        "https://ap2.chinet.org/assets/img/user_img_placeholder.png";
    },
  },
};
</script>

<style scoped>
/* au pair photos */

.chi-photo {
  max-width: 250px;
  background-position: cover;
}

.chi-photo img {
  border: 15px solid #f4f4f4;
  border-radius: 50%;
  max-width: 250px;
  max-height: 250px;
  height: 250px;
  width: 250px;
  object-fit: cover;
  background-position: 50% 50%;
}

.chi-photo-xs {
  max-width: 125px;
  background-position: cover;
}

.chi-photo-xs img {
  border: 5px solid #f4f4f4;
  border-radius: 50%;
  max-width: 125px;
  max-height: 125px;
  height: 125px;
  width: 125px;
  object-fit: cover;
  background-position: 50% 50%;
}
</style>
